import { enUS } from "@mui/material/locale";
import createTheme from "@mui/material/styles/createTheme";
import { enUS as dataGridEnUS } from "@mui/x-data-grid/locales/enUS";
import { enUS as datePickerEnUS } from "@mui/x-date-pickers/locales/enUS";
import { getThemeOptions } from "./getThemeOptions";
export const getTheme = (dt, ...locale) => {
    const themeOptions = getThemeOptions(dt);
    const mergedLocale = [...[enUS, dataGridEnUS, datePickerEnUS], ...locale];
    const theme = createTheme(themeOptions, ...mergedLocale);
    return theme;
};
